export default "__VITE_ASSET__xBrWMmdP__"